(function(){'use strict';
  var root=document.querySelector('[data-ckb-product-learning]');
  var map=window.CKB_PRODUCT_LEARNING_MAP;
  if(!root||!map||!Array.isArray(map.profiles))return;
  function norm(v){return String(v||'').toLowerCase().replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').trim();}
  function contains(text,term){return (' '+text+' ').indexOf(' '+term+' ')>-1;}
  function esc(v){var d=document.createElement('div');d.textContent=String(v||'');return d.innerHTML;}
  var title=root.getAttribute('data-product-title')||'';
  var handle=root.getAttribute('data-product-handle')||'';
  var normalized=norm(title);
  if(/(^| )ld 3( |$)/.test(normalized)||/f loop 4 0|f loop pro v2|(^| )cha art( |$)/.test(normalized))return;
  var matches=[];
  map.profiles.forEach(function(profile){
    [profile.name].concat(profile.aliases||[]).forEach(function(alias){var a=norm(alias);if(a&&contains(normalized,a))matches.push({profile:profile,length:a.length});});
  });
  matches.sort(function(a,b){return b.length-a.length;});
  var profile=matches.length?matches[0].profile:null;
  if(!profile||!profile.articles||!profile.articles.length)return;
  var heading=root.querySelector('[data-ckb-learning-heading]');
  var grid=root.querySelector('[data-ckb-learning-grid]');
  var actions=root.querySelector('[data-ckb-learning-actions]');
  if(heading)heading.textContent='Learn About '+profile.name;
  if(grid)grid.innerHTML=profile.articles.map(function(a){return '<a class="ckb-learning-card" href="'+esc(a.url)+'"><span class="ckb-learning-card__role">'+esc(a.role)+'</span><strong>'+esc(a.title)+'</strong><span>'+esc(a.quick)+'</span><em>Read handbook page →</em></a>';}).join('');
  var base='/pages/chameleon-knowledge-base?product='+encodeURIComponent(profile.name)+'&handle='+encodeURIComponent(handle);
  var buttons='<a class="ckb-learning-button ckb-learning-button--primary" href="'+esc(base)+'">Open Complete Handbook</a>';
  if(profile.builderSupported)buttons+='<a class="ckb-learning-button" href="'+esc(base+'&tool=builder#ckb-system-builder')+'">Build with it</a>';
  else buttons+='<a class="ckb-learning-button" href="/pages/chameleon-knowledge-base?search=Antenna%20Selection">Explore Antenna Selection</a>';
  buttons+='<a class="ckb-learning-button" href="/pages/chameleon-knowledge-base?tool=operating-platform&add='+encodeURIComponent(handle)+'#ckb-operating-platform">Add to My Equipment</a>';
  if(actions)actions.innerHTML=buttons;
  root.hidden=false;
  root.setAttribute('data-ckb-profile',profile.name);
})();
